export default __webpack_public_path__ + "static/media/FTM.9ed58dbf.svg";